const localStorageKeys = {
  USER_VOLUME: "userVolume",
};

export { localStorageKeys };
